<script setup lang="ts">
import BaseButton from '@/js/account/components/base/BaseButton.vue';
import BaseIcon from '@/js/account/components/base/BaseIcon.vue';
import { classNames } from '@/js/lib/bem';

defineProps<{
  label: string
}>();

const emit = defineEmits<{
  create: []
}>();

const cn = classNames('create-button');
</script>

<template>
  <BaseButton
    theme="primary"
    size="sm"
    :class="cn()"
    @click="emit('create')"
  >
    <BaseIcon
      name="x"
      :width="16"
      :height="16"
      :class="cn('icon')"
    />
    {{ label }}
  </BaseButton>
</template>

<style lang="scss" scoped>
.create-button {
  gap: 8px;

  &__icon {
    transform: rotate(45deg);
  }
}
</style>
